"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeGen = void 0;
var utils_1 = require("../utils");
/**
 * Base class for all code generators.
 */
var CodeGen = /** @class */ (function () {
    function CodeGen(schema) {
        this.schema = schema;
    }
    /**
     * Given a schema, it will generate code for both the schema and the schemas in its definitions section
     */
    CodeGen.prototype.transpile = function () {
        var _this = this;
        if (this.schema === true || this.schema === false) {
            var ir = this.toIR(this.schema);
            return ir.typing.trim();
        }
        var imports = new Set();
        var rootSchemaTypes = "";
        if (this.schema.$ref === undefined) {
            this.schema.$ref = "#/definitions/" + this.schema.title; // hack, i think dont need anymore
            var ir = this.toIR(this.schema);
            rootSchemaTypes = this.generate(this.schema, ir);
            if (ir.imports) {
                ir.imports.forEach(function (imp) { return imports.add(imp); });
            }
            if (this.schema.$ref) { // hack
                delete this.schema.$ref; // hack
            } // hack
        }
        var defsSchemaTypes = [];
        if (this.schema.definitions !== undefined) {
            Object
                .entries(this.schema.definitions)
                .filter(function (_a) {
                var n = _a[0];
                return n !== _this.schema.title;
            })
                .forEach(function (_a) {
                var n = _a[0], schema = _a[1];
                var ir = _this.toIR(schema);
                if (ir.imports) {
                    ir.imports.forEach(function (imp) { return imports.add(imp); });
                }
                if (schema === true || schema === false) {
                    defsSchemaTypes.push(ir.typing);
                    return;
                }
                defsSchemaTypes.push(_this.generate(schema, ir));
            });
        }
        return __spreadArray(__spreadArray(__spreadArray([], Array.from(imports)), defsSchemaTypes), [
            rootSchemaTypes,
        ]).join("\n").trim();
    };
    /**
     * Generic title transform that gives a title without special characters or spaces. It may be overriden if
     * this implementation does not suffice.
     */
    CodeGen.prototype.getSafeTitle = function (title) {
        return utils_1.languageSafeName(title);
    };
    CodeGen.prototype.getCodePrefix = function () { return ""; };
    CodeGen.prototype.refToTitle = function (schema) {
        if (schema === true) {
            return "AlwaysTrue";
        }
        if (schema === false) {
            return "AlwaysFalse";
        }
        if (schema.$ref === undefined) {
            var stringed = "";
            try {
                stringed = JSON.stringify(schema);
            }
            catch (e) {
                stringed = "title: " + schema.title + " - type: " + schema.type;
            }
            throw new Error([
                "the Subschemas of the schema must use $ref. Inline subschemas are not allowed.",
                "the schema in question: ",
                stringed,
            ].join("\n"));
        }
        return schema.$ref.replace("#/definitions/", "");
    };
    CodeGen.prototype.getJoinedSafeTitles = function (schemas, seperator) {
        if (seperator === void 0) { seperator = ", "; }
        return schemas
            .map(this.refToTitle)
            .map(this.getSafeTitle.bind(this))
            .join(seperator);
    };
    CodeGen.prototype.toIR = function (s) {
        if (s === true || s === false) {
            return this.handleConstantBool(s);
        }
        switch (s.type) {
            case "boolean": return this.handleBoolean(s);
            case "null": return this.handleNull(s);
            case "number":
                if (s.enum) {
                    return this.handleNumericalEnum(s);
                }
                return this.handleNumber(s);
            case "integer":
                if (s.enum) {
                    return this.handleNumericalEnum(s);
                }
                return this.handleInteger(s);
            case "string":
                if (s.enum) {
                    return this.handleStringEnum(s);
                }
                return this.handleString(s);
            case "array":
                if (s.items instanceof Array) {
                    return this.handleOrderedArray(s);
                }
                if (s.items !== undefined) {
                    return this.handleUnorderedArray(s);
                }
                return this.handleUntypedArray(s);
            case "object":
                if (s.properties === undefined) {
                    return this.handleUntypedObject(s);
                }
                return this.handleObject(s);
            default:
                if (s.anyOf) {
                    return this.handleAnyOf(s);
                }
                if (s.oneOf) {
                    return this.handleOneOf(s);
                }
                if (s.allOf) {
                    return this.handleAllOf(s);
                }
                return this.handleUntyped(s);
        }
    };
    return CodeGen;
}());
exports.CodeGen = CodeGen;
